<template>
  <div class="zen-change-action">
    <span v-if="isDone" class="zen-change-action__done">
      <span class="icon-checkmark"></span>
      {{ doneLabel }}
    </span>

    <button v-else-if="isLoading" class="zen-bttn" disabled>
      <span class="zen-spinner"></span>
    </button>

    <div v-else-if="isConfirming" class="zen-change-action__confirm">
      <span class="zen-change-action__confirm-text">{{ $t('vue2.zen_import.confirm') }}</span>
      <button class="zen-bttn zen-bttn--danger" @click="$emit('confirm')">
        {{ $t('vue2.zen_import.yes') }}
      </button>
      <button class="zen-bttn" @click="$emit('setState', 'idle')">
        {{ $t('vue2.zen_import.cancel') }}
      </button>
    </div>

    <button v-else
            class="zen-bttn"
            :class="{'zen-bttn--danger-outline': actionType === 'delete'}"
            @click="$emit('setState', 'confirming')">
      {{ actionLabel }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    actionType: {
      type: String,
      default: 'delete'
    },
    state: {
      type: String,
      default: 'idle'
    }
  },
  computed: {
    isConfirming () {
      return this.state === 'confirming'
    },
    isLoading () {
      return this.state === 'loading'
    },
    isDone () {
      return this.state === 'deleted' || this.state === 'reverted'
    },
    actionLabel () {
      return this.actionType === 'delete'
        ? this.$t('vue2.zen_import.delete')
        : this.$t('vue2.zen_import.undo_change')
    },
    doneLabel () {
      return this.state === 'deleted'
        ? this.$t('vue2.zen_import.done_deleted')
        : this.$t('vue2.zen_import.done_reverted')
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.zen-change-action {
  display: flex;
  align-items: center;
}

.zen-change-action__confirm {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.zen-change-action__confirm-text {
  font-size: 0.85rem;
  color: #6b7280;
}

.zen-bttn {
  height: 28px;
  padding: 0 0.75rem;
  font-size: 0.85rem;
  white-space: nowrap;
  min-width: 40px;
}

.zen-bttn--danger {
  background-color: var(--danger);
  border-color: var(--danger);
  color: #ffffff;
}

.zen-bttn--danger:hover {
  background-color: var(--danger);
  opacity: 0.9;
}

.zen-bttn--danger-outline {
  color: var(--danger);
  background-color: #ffffff;
}

.zen-bttn--danger-outline:hover {
  background-color: var(--danger);
  color: #ffffff;
}

.zen-change-action__done {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: #16a34a;
  font-weight: 600;
}

.zen-spinner {
  display: inline-block;
  height: 14px;
  width: 14px;
  border: 2px solid var(--blue, #468ad7);
  border-left-color: transparent;
  border-radius: 50%;
  animation: zen-spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes zen-spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// ZenChangeAction.vue?6d9ab706